<template>
    <div id="stuff">
        <evolucao-vendas />
    </div>
</template>

<script>
import EvolucaoVendas from './EvolucaoVendas';
import ProgressCard from './ProgressCard';

export default {
    data() {
        return {
            tetop: 20,
        };
    },
    components: {
        EvolucaoVendas,
        ProgressCard,
    },
};
</script>

<style lang="scss" scoped>
#stuff {
    padding: 20px;
}
</style>
